import { isClientSideRendered as e } from "../../utils/ssr.js";
var n = function n() {
  var n;
  var i;
  var r = e() && (null === (n = null === window || void 0 === window ? void 0 : window.navigator) || void 0 === n ? void 0 : n.userAgent);
  return r && (i = r.indexOf("Firefox") > -1 ? "firefox" : r.indexOf("SamsungBrowser") > -1 ? "samsung" : r.indexOf("Opera") > -1 || r.indexOf("OPR") > -1 ? "opera" : r.indexOf("Trident") > -1 ? "ie" : r.indexOf("Edge") > -1 ? "edge" : r.indexOf("Chrome") > -1 || navigator.userAgent.indexOf("CriOS") > -1 ? "chrome" : r.indexOf("Safari") > -1 ? "safari" : "unknown"), i;
};
export { n as default };